import { Box } from "@bigcommerce/big-design";
import styled from "styled-components";

export const FileUploaderBox = styled(Box)`
  div > button {
    width: initial;
  }
`;